var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectMailTable(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 284.508,
    viewBox: "0 0 330.419 284.508",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3127",
    "data-name": "Group 3127",
    transform: "translate(-550 -3302)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 245.838,
    height: 252.548,
    transform: "translate(550.162 3302)",
    fill: "#f8f8f9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1550",
    "data-name": "Rectangle 1550",
    width: 74.838,
    height: 252.548,
    transform: "translate(805.581 3302)",
    fill: "#f8f8f9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    x2: 147.717,
    transform: "translate(550.026 3342.81)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_170",
    "data-name": "Line 170",
    x2: 74.393,
    transform: "translate(805.607 3342.81)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    x2: 147.717,
    transform: "translate(550.026 3362.01)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_171",
    "data-name": "Line 171",
    x2: 74.393,
    transform: "translate(805.607 3362.01)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    x2: 147.717,
    transform: "translate(550.026 3381.209)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_172",
    "data-name": "Line 172",
    x2: 74.393,
    transform: "translate(805.607 3381.209)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 147.717,
    transform: "translate(550.026 3400.408)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_173",
    "data-name": "Line 173",
    x2: 74.393,
    transform: "translate(805.607 3400.408)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x2: 147.717,
    transform: "translate(550 3419.608)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_174",
    "data-name": "Line 174",
    x2: 74.393,
    transform: "translate(805.581 3419.608)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x2: 147.717,
    transform: "translate(550.026 3438.807)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175",
    "data-name": "Line 175",
    x2: 74.393,
    transform: "translate(805.607 3438.807)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    x2: 147.717,
    transform: "translate(550.026 3458.007)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    x2: 74.393,
    transform: "translate(805.607 3458.007)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    x2: 147.717,
    transform: "translate(550.026 3477.206)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    x2: 74.393,
    transform: "translate(805.607 3477.206)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x2: 147.717,
    transform: "translate(550.026 3496.405)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    x2: 74.393,
    transform: "translate(805.607 3496.405)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x2: 147.717,
    transform: "translate(550.026 3515.605)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    "data-name": "Line 179",
    x2: 74.393,
    transform: "translate(805.607 3515.605)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x2: 147.717,
    transform: "translate(550.026 3534.805)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_180",
    "data-name": "Line 180",
    x2: 74.393,
    transform: "translate(805.607 3534.805)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M0,0H244.974",
    transform: "translate(550.026 3554.548)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M0,0H74.419",
    transform: "translate(805.581 3554.548)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x2: 246.474,
    transform: "translate(550.026 3323.611)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_169",
    "data-name": "Line 169",
    x2: 74.419,
    transform: "translate(805.581 3323.611)",
    fill: "none",
    stroke: "#a7a9ac",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec",
    "data-name": "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec",
    transform: "translate(582 3336.181)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -19.77,
    y: 0
  }, "Jan"), /*#__PURE__*/React.createElement("tspan", {
    x: -19.723,
    y: 19.4
  }, "Feb"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.064,
    y: 38.8
  }, "Mar"), /*#__PURE__*/React.createElement("tspan", {
    x: -18.621,
    y: 58.2
  }, "Apr"), /*#__PURE__*/React.createElement("tspan", {
    x: -22.682,
    y: 77.6
  }, "May"), /*#__PURE__*/React.createElement("tspan", {
    x: -19.857,
    y: 97
  }, "Jun"), /*#__PURE__*/React.createElement("tspan", {
    x: -16.148,
    y: 116.4
  }, "Jul"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.111,
    y: 135.8
  }, "Aug"), /*#__PURE__*/React.createElement("tspan", {
    x: -20.209,
    y: 155.2
  }, "Sep"), /*#__PURE__*/React.createElement("tspan", {
    x: -18.451,
    y: 174.6
  }, "Oct"), /*#__PURE__*/React.createElement("tspan", {
    x: -21.123,
    y: 194
  }, "Nov"), /*#__PURE__*/React.createElement("tspan", {
    x: -20.508,
    y: 213.4
  }, "Dec")), /*#__PURE__*/React.createElement("text", {
    id: "Patients",
    transform: "translate(843 3317.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.389,
    y: 0
  }, "Patients")), /*#__PURE__*/React.createElement("text", {
    id: "_14_16_18_12_7_21_22_17_24_21_23_28_223",
    "data-name": "14 16 18 12 7 21 22 17 24 21 23 28 223",
    transform: "translate(674 3336.551)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 0
  }, "14"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 19.4
  }, "16"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 38.8
  }, "18"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 58.2
  }, "12"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 77.6
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 97
  }, "21"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 116.4
  }, "22"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 135.8
  }, "17"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 155.2
  }, "24"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 174.6
  }, "21"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 194
  }, "23"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 213.4
  }, "28"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.327,
    y: 232.8
  }, "223"))), /*#__PURE__*/React.createElement("text", {
    id: "Calls",
    transform: "translate(674 3317.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.409,
    y: 0
  }, "Calls")), /*#__PURE__*/React.createElement("text", {
    id: "_.42_",
    "data-name": ".42%",
    transform: "translate(717.32 3570.551)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.058,
    y: 0
  }, ".42%")), /*#__PURE__*/React.createElement("text", {
    id: "_45_",
    "data-name": "45%",
    transform: "translate(770.32 3570.551)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -11.314,
    y: 0
  }, "45%")), /*#__PURE__*/React.createElement("text", {
    id: "Call_",
    "data-name": "Call %",
    transform: "translate(717 3317.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -16.248,
    y: 0
  }, "Call %")), /*#__PURE__*/React.createElement("text", {
    id: "Call_Conv.",
    "data-name": "Call Conv.",
    transform: "translate(768 3317.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -26.783,
    y: 0
  }, "Call Conv.")), /*#__PURE__*/React.createElement("text", {
    id: "Mailers",
    transform: "translate(621 3317.351)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20.171,
    y: 0
  }, "Mailers")), /*#__PURE__*/React.createElement("text", {
    id: "_3_400_3_400_3_400_3_400_3_600_3_600_3_600_3_800_3_800_3_800_3_800_3_800_12",
    "data-name": "3,400 3,400 3,400 3,400 3,600 3,600 3,600 3,800 3,800 3,800 3,800 3,800 12",
    transform: "translate(621.567 3336.547)",
    fill: "#7f7f7f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 0
  }, "3,400"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 19.4
  }, "3,400"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 38.8
  }, "3,400"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 58.2
  }, "3,400"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 77.6
  }, "3,600"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 97
  }, "3,600"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 116.4
  }, "3,600"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 135.8
  }, "3,800"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 155.2
  }, "3,800"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 174.6
  }, "3,800"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 194
  }, "3,800"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.654,
    y: 213.4
  }, "3,800"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.885,
    y: 232.8
  }, "12"))), /*#__PURE__*/React.createElement("text", {
    id: "_6_5_8_4_3_9_15_8_13_6_11_14_100",
    "data-name": "6 5 8 4 3 9 15 8 13 6 11 14 100",
    transform: "translate(843 3337.547)",
    fill: "#b94f4f",
    fontSize: 12,
    fontFamily: "Roboto-Regular, Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 0
  }, "6"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 19.4
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 38.8
  }, "8"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 58.2
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 77.6
  }, "3"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 97
  }, "9"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 116.4
  }, "15"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 135.8
  }, "8"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 155.2
  }, "13"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.369,
    y: 174.6
  }, "6"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 194
  }, "11"), /*#__PURE__*/React.createElement("tspan", {
    x: -6.738,
    y: 213.4
  }, "14"), /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "Roboto-Bold, Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.327,
    y: 232.8
  }, "100"))), /*#__PURE__*/React.createElement("text", {
    id: "Mailings",
    transform: "translate(604.28 3582.508)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Avenir-Roman, Avenir"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mailings")), /*#__PURE__*/React.createElement("text", {
    id: "Total",
    transform: "translate(674 3582.508)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Avenir-Roman, Avenir"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.84,
    y: 0
  }, "Total")), /*#__PURE__*/React.createElement("text", {
    id: "Total-2",
    "data-name": "Total",
    transform: "translate(843 3582.508)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Avenir-Roman, Avenir"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10.84,
    y: 0
  }, "Total")), /*#__PURE__*/React.createElement("text", {
    id: "Averages",
    transform: "translate(724.28 3582.508)",
    fill: "#7f7f7f",
    fontSize: 10,
    fontFamily: "Avenir-Roman, Avenir"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Averages")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectMailTable);
export default __webpack_public_path__ + "static/media/directMailTable.6650e95f.svg";
export { ForwardRef as ReactComponent };